import {
  FormField,
  FormItem,
  FormControl,
  FormMessage,
} from "@/components/ui/form";
import { useFormContext } from "react-hook-form";
import { Input } from "@/components/ui/input";
import { Euro } from "lucide-react";

const domicilePresets = [
  { label: "Économique", value: "50", sub: "~50€ / pers." },
  { label: "Intermédiaire", value: "75", sub: "~75€ / pers." },
  { label: "Premium", value: "100", sub: "~100€ / pers." },
  { label: "Luxe", value: "150", sub: "~150€ / pers." },
  { label: "Sur mesure", value: "200", sub: "200€+ / pers." },
];

const demeurePresets = [
  { label: "Essentiel", value: "300", sub: "~300€ / jour" },
  { label: "Confort", value: "500", sub: "~500€ / jour" },
  { label: "Premium", value: "700", sub: "~700€ / jour" },
  { label: "Excellence", value: "1000", sub: "~1 000€ / jour" },
  { label: "Sur mesure", value: "1500", sub: "1 500€+ / jour" },
];

export const Step5Budget = () => {
  const form = useFormContext();
  const chefType = form.watch("chefType");
  const isDemeure = chefType === "DEMEURE";

  const presets = isDemeure ? demeurePresets : domicilePresets;
  const unit = isDemeure ? "€ / jour" : "€ / pers.";
  const placeholder = isDemeure
    ? "Forfait journalier souhaité"
    : "Budget maximum par convive (approximatif)";

  return (
    <FormField
      control={form.control}
      name="budget"
      render={({ field }) => (
        <FormItem className="space-y-6 w-full">
          <div className="flex flex-col gap-1 mb-2">
            <h1 className="font-h2 text-dark-blue">
              {isDemeure ? "Forfait journalier ?" : "Quel est votre budget ?"}
            </h1>
            <p className="font-p text-muted-foreground">
              {isDemeure
                ? "Budget approximatif par jour de présence du chef (tout compris)."
                : "Budget maximum approximatif par convive."}
            </p>
          </div>

          {/* Preset cards */}
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
            {presets.map((preset) => {
              const selected = field.value === preset.value;
              return (
                <button
                  key={preset.value}
                  type="button"
                  onClick={() => field.onChange(preset.value)}
                  className={`flex flex-col items-start p-4 rounded-2xl border-2 text-left transition-all duration-200 ${
                    selected
                      ? "border-primary bg-primary/5 shadow-sm shadow-primary/10"
                      : "border-border bg-white hover:border-gray-300 hover:shadow-sm"
                  }`}
                >
                  <span
                    className={`text-sm font-bold mb-0.5 ${selected ? "text-primary" : "text-dark-blue"}`}
                  >
                    {preset.label}
                  </span>
                  <span className="text-xs text-muted-foreground">
                    {preset.sub}
                  </span>
                </button>
              );
            })}
          </div>

          {/* Champ libre */}
          <div className="space-y-1.5">
            <p className="text-xs font-semibold text-muted-foreground uppercase tracking-wider">
              Ou entrez un montant précis
            </p>
            <FormControl>
              <div className="relative bg-white">
                <div className="absolute left-3.5 top-1/2 -translate-y-1/2">
                  <div className="p-1 bg-primary/15 rounded-md">
                    <Euro size={14} className="text-primary" />
                  </div>
                </div>
                <Input
                  type="text"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  placeholder={placeholder}
                  className="pl-12 pr-20 h-12 rounded-xl border-2 focus:border-primary"
                  {...field}
                  onChange={(e) =>
                    field.onChange(e.target.value.replace(/[^\d]/g, ""))
                  }
                />
                <div className="absolute right-4 top-1/2 -translate-y-1/2 text-sm text-muted-foreground font-medium whitespace-nowrap">
                  {unit}
                </div>
              </div>
            </FormControl>
          </div>

          <FormMessage />
        </FormItem>
      )}
    />
  );
};
